export default __webpack_public_path__ + "static/media/greed-semibold.92928ae5.otf";